import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { BASE_URL } from "../../../api/rootApi";

const AddProduct = () => {
  const navigate = useNavigate();
  const redirect_uri = "/explore";
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    fetch(`${BASE_URL}/products`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        alert("Product Added Successfully!");
        reset();
        navigate(redirect_uri);
      });
  };

  return (
    <div className="flex flex-col items-center py-12">
      <div className="w-full max-w-xl">
        <h2 className="text-center text-2xl font-bold mb-6">
          Add a New Product
        </h2>
        <div className="bg-white shadow-lg rounded-lg p-6">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <input
              {...register("title")}
              placeholder="Title"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900"
            />
            <input
              {...register("img")}
              type="url"
              placeholder="Image URL"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900"
            />
            <input
              {...register("details")}
              type="text"
              placeholder="Details"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900"
            />
            <input
              {...register("size")}
              type="text"
              placeholder="Size"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900"
            />
            <input
              {...register("price")}
              placeholder="Price in BDT"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900"
            />
            {errors.exampleRequired && (
              <span className="text-red-500 text-sm">
                This field is required
              </span>
            )}
            <input
              type="submit"
              value="Confirm Submit"
              className="w-full py-2.5 bg-slate-900 text-white font-medium rounded-lg hover:bg-amber-500 hover:text-slate-900 transition-all duration-300 cursor-pointer"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
